import { IoDocumentTextOutline, IoGridOutline } from "react-icons/io5";
import { LuLink, LuClipboardCheck } from "react-icons/lu";
import { HiOutlinePencilAlt } from "react-icons/hi";
import { SidebarShell } from "./SidebarShell";

const sideBaseStyle =
  "flex items-center justify-start rounded-md px-4 py-4 gap-3 whitespace-nowrap";
const sideActiveStyle = `${sideBaseStyle} bg-white text-subcolor font-bold`;
const sideInactiveStyle = `${sideBaseStyle} text-white opacity-40 cursor-default`;

export function CompetitionListSidebar() {
  return (
    <SidebarShell>
      <li className="px-[10px] py-[5px]">
        <div className={sideActiveStyle}>
          <IoGridOutline size={18} /><span>コンペティション一覧</span>
        </div>
      </li>
      <li className="px-[10px] py-[5px]">
        <div className={sideInactiveStyle}>
          <IoDocumentTextOutline size={18} /><span>概要</span>
        </div>
      </li>
      <li className="px-[10px] py-[5px]">
        <div className={sideInactiveStyle}>
          <LuLink size={18} /><span>関連データ</span>
        </div>
      </li>
      <li className="px-[10px] py-[5px]">
        <div className={sideInactiveStyle}>
          <LuClipboardCheck size={18} /><span>リーダーボード</span>
        </div>
      </li>
      <li className="px-[10px] py-[5px]">
        <div className={sideInactiveStyle}>
          <HiOutlinePencilAlt size={18} /><span>投稿</span>
        </div>
      </li>
    </SidebarShell>
  );
}
